import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardDetailsComponent } from '../components/card-details/card-details.component';
import { CardListComponent } from '../components/card-list/card-list.component';
import { CardPaymentComponent } from '../components/card-payment/card-payment.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [CardDetailsComponent, CardListComponent, CardPaymentComponent],
  exports: [CardDetailsComponent, CardListComponent, CardPaymentComponent],
  entryComponents: [CardDetailsComponent]
})
export class CardSharedModule { }
